export default "__VITE_ASSET__DFaCU2uS__"